import { render } from "./Swiper.vue?vue&type=template&id=ff47f82e&scoped=true&bindings={\"list\":\"props\",\"goTo\":\"options\"}"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=ff47f82e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ff47f82e"

export default script